import { createRecipe } from './runtime';

const spinnerConfig = {"name":"spinner","defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm","xl","xs"]}}

export const spinner = /* @__PURE__ */ createRecipe(spinnerConfig)